export default {
    data(){
        return{
    cn: {
      plan_and_cases_title: '方案与案例',
      sectors : [
        { 
            name: 'film_television', 
            image: require('@/assets/img/PlanandCases/PlanandCasesHome/FilmTelevision.jpg'),
            displayName: '影视', 
            class: 'film_television', 
            show: false ,
            description:'description',
          },
          { 
            name: 'culture_tour', 
            image: require('@/assets/img/PlanandCases/PlanandCasesHome/CultureTour.jpg'),
            displayName: '文化旅游', 
            class: 'culture_tour', 
            show: false,
            description:'description',
          },
          { 
            name: 'digital_assets',
            image: require('@/assets/img/PlanandCases/PlanandCasesHome/DigitalAssets.png'),
            displayName: '数字资产', 
            class: 'digital_assets', 
            show: false,
            description:'description',
          },
          { 
            name: 'aigc', 
            image: require('@/assets/img/PlanandCases/PlanandCasesHome/AIGC.png'),
            displayName: 'AIGC', 
            class: 'aigc', 
            show: false,
            description:'description',
          },
            // Add more sectors as needed
      ],
      
      dropdown_sectors : [
        // film_television
          { 
            name: 'film_television', 
            image: require('@/assets/img/PlanandCases/PlanandCasesHome/DropDown/FilmTelevision_DreamWater.jpg'),
            displayName: '虚拟制片：《梦之海》', 
            displaySectionName: '影视', 
            class: 'film_television', 
            show: false ,
            description:
                '为《梦之海》剧组提供虚拟制片技术支持，以实现太空冰川、末日废土等剧本场景的虚拟拍摄',
            DetailFolderName: 'filmAndTelevision', 
            DetailPageName: "DreamWaterPage"  
          },
          // 根据敬基的需求，暂时不需要白蛇这个案例
        // digital_assets
          { 
            name: 'digital_assets', 
            image: require('@/assets/img/PlanandCases/PlanandCasesHome/DropDown/DigitalAssets_BeijiaoPictureWallOpacity.png'),
            displayName: '北交数字博物馆', 
            displaySectionName: '数字资产',
            class: 'digital_assets', 
            show: false,
            description:
                '2023年7月，北京交通大学运输设备教学馆启动搬迁，云翰虹章采用逆向建模与正向建模相结合的方法，成功完成展品数字化建模，并于2024年7月顺利结项',
            DetailFolderName: 'digitalAssets',     
            DetailPageName: "BeijiaoDigitalMuseumPage"
          },
          { 
            name: 'digital_assets',  
            image: require('@/assets/img/PlanandCases/PlanandCasesHome/DropDown/DigitalAssets_Ceramsite.png'),
            displayName: '基于虚幻引擎的陶粒工厂生产工艺流程演示片', 
            displaySectionName: '数字资产',
            class: 'digital_assets', 
            show: false,
            description:
                '云翰虹章团队为一家陶粒板材工厂制作了一段CG动画，全面展示了其生产流程细节、产品亮点以及技术底蕴',
            DetailFolderName: 'digitalAssets',     
            DetailPageName: "CeramsiteFactoryPage"
          },
            // Add more dropdown as needed
      ],
      
      dropdown_sectors2 : [
        // culture_tour
          { 
            name: 'culture_tour',
            image: require('@/assets/img/PlanandCases/PlanandCasesHome/DropDown/CultureTour_LightShow.png'),
            displayName: '象山影视城-城墙投影', 
            displaySectionName: '文化旅游',
            class: 'culture_tour', 
            show: false,
            description:
                '基于虚幻引擎的超写实CG动画制作，结合了传统的舞蹈表演与投影技术，为游客呈现了一场视觉盛宴',
            DetailFolderName: 'cultureTour',     
            DetailPageName: "CityWallProjectionPage"    
          },
          { 
            name: 'culture_tour', 
            image: require('@/assets/img/PlanandCases/PlanandCasesHome/DropDown/CultureTour_VRPark.jpg'),
            displayName: 'VR Park 宁波方特场馆', 
            displaySectionName: '文化旅游',
            class: 'culture_tour', 
            show: false,
            description:
                '匈牙利VR Vidámpark在中国的首个家庭娱乐度假场所，中外文旅合作的杰出代表',
            DetailFolderName: 'cultureTour',    
            DetailPageName: "VRParkCasesPage"
          },
          { 
            name: 'culture_tour', 
            image: require('@/assets/img/PlanandCases/PlanandCasesHome/DropDown/CultureTour_VRParkNingboScience.jpeg'),
            displayName: '宁波科学探索中心店-童话镇', 
            displaySectionName: '文化旅游',
            class: 'culture_tour', 
            show: false,
            description:
                '宁波市区内首个VR LBE大空间主题场馆, 科普与娱乐相结合的科学探索中心',
            DetailFolderName: 'cultureTour',    
            DetailPageName: "VRParkNingboScience"
          },
          // 根据单靠的需求，暂时不需要AI绘画这个案例
        // aigc
          { 
            name: 'aigc', 
            image: require('@/assets/img/PlanandCases/PlanandCasesHome/DropDown/AIGC_MetaHumanShangguan.jpg'),
            displayName: 'Bata-Human', 
            displaySectionName: 'AIGC',
            class: 'aigc', 
            show: false,
            description:
                '云翰虹章推出的虚拟数字人不仅具备自然的语言交互能力和基本的情感识别功能，还拥有精心设计的外型，能够与用户进行流畅对话，并根据用户情绪调整对话策略，为用户提供良好的互动体验',
            DetailFolderName: 'AIGC',
            DetailPageName: "BataHumanPage"
          },
            // Add more dropdown as needed
      ],

    }
}
}
};
  